@if (isTradableTx()) {
  <tradable-transaction-list-item
    [showShareButton]="showShareButton"
    [transaction]="transaction"
    [canOpen]="false"
    [activity]="activity"
    (closeEmitter)="onCloseEmitted($event)">
  </tradable-transaction-list-item>
} @else {
  <fiat-transaction-list-item
    [showShareButton]="showShareButton"
    [transaction]="transaction"
    [canOpen]="false"
    [activity]="activity"
    (closeEmitter)="onCloseEmitted($event)">
  </fiat-transaction-list-item>
}
